@for (toast of toastService.toasts; track toast) {
<ngb-toast [class]="toast.panelClass" [autohide]="true" [delay]="toast.delay || 5000"
    (hidden)="toastService.remove(toast)">
    {{toast.message}}
</ngb-toast>
}